<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY</span> <br/>M<span class="smallcaps">ASSIMO</span> C<span class="smallcaps">ARLOTTO</span></h1>
<p class="center"><i>The Goodbye Kiss</i></p>
<p class="center"><i>Death’s Dark Abyss</i></p>
<p class="center"><i>The Fugitive</i></p>
<p class="center"><i>Poisonville</i> (with Marco Videtta)</p>
<p class="center"><i>Bandit Love</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?7f9f7a76